import React from 'react';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Team } from '../../models/types';
import { StatTile } from '../ui/StatTile';
import { formatPaceLabel } from './teamDetailFormatters';
import { formatNumber } from '../../i18n/locale-format';

export interface TeamStatsData {
  totalDistance: number;
  averagePace: number;
  totalTracklog: number;
  fastestPace: number;
  maxDistance: number;
}

interface TeamDetailStatsGridProps {
  team: Team;
  stats: TeamStatsData | null;
  loading: boolean;
}

// Compact tiles; auto-fit keeps two columns at phone width and more on desktop.
export const TeamDetailStatsGrid = ({ team, stats, loading }: TeamDetailStatsGridProps) => {
  const { t } = useTranslation('teams');
  const km = (value: number) => t('common:units.km', { value: formatNumber(value, { minimumFractionDigits: 1, maximumFractionDigits: 1 }) });
  const stat = (render: (s: TeamStatsData) => string) => (loading ? '...' : stats ? render(stats) : '--');
  return (
    <Box sx={{ display: 'grid', gap: 1.5, gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))' }}>
      <StatTile variant="compact" label={t('stats.members')} value={team.numberOfMember} />
      <StatTile variant="compact" label={t('stats.totalDistance')} value={stat(s => km(s.totalDistance))} />
      <StatTile variant="compact" label={t('stats.averagePace')} value={stat(s => formatPaceLabel(s.averagePace))} />
      <StatTile variant="compact" label={t('stats.fastestPace')} value={stat(s => formatPaceLabel(s.fastestPace))} />
      <StatTile variant="compact" label={t('stats.trackDays')} value={stat(s => String(s.totalTracklog))} />
      <StatTile variant="compact" label={t('stats.maxDistance')} value={stat(s => km(s.maxDistance))} />
    </Box>
  );
};
